import { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ReportComponent from './ReportComponent';
import HistoryComponent from './HistoryComponent';
export default (() => {
    const [activeKey, setActiveKey] = useState('report');
    return <section className='projects-section uploadtab'>
        <Tabs id="controlled-tab-example" activeKey={activeKey} onSelect={(k) => setActiveKey(k)} className="mb-1">
            <Tab eventKey="report" title="Generate Report">
                <ReportComponent />
            </Tab>
            <Tab eventKey="history" title="History">
                <HistoryComponent activeKey={activeKey} />
            </Tab>
        </Tabs>
    </section>
})
